
export class Payment {
    id: string; //response
    token: string; //response
    create_time: string; //response
    update_time: string; //response
    state: string; //response
    intent: string;
    payer: Payer;
    transactions: Transaction[];
    note_to_payer: string;
    redirect_urls: RedirectUrls;
    payee: Payee;
    cartGuid: string; // for logging
}

export class Payer {
    payment_method: string;
    status: string;
    payer_info: PayerInfo;
}

export class Payee {
    email: string;
    merchant_id: string;
}

export class PayerInfo {
    email: string;
    first_name: string;
    last_name: string;
    payer_id: string;
    shipping_address: ShippingAddress;
    country_code: string;
    phone: string;
}

export class Details {
    subtotal: string;
    tax: string;
    shipping: string;
    handling_fee: string;
    shipping_discount: string;
    insurance: string;
}

export class Amount {
    total: string;
    currency: string;
    details: Details;
}

export class PaymentOptions {
    allowed_payment_method: string;
}

export class Order {
    id: string;
    create_time: string;
    update_time: string;
    state: string;
    amount: Amount;
    parent_payment: string;
    links: Link[];
}

export interface RelatedResource {
    order: Order;
}
export interface Link {
    href: string;
    rel: string;
    method: string;
}

export class Item {
    name: string;
    description: string;
    quantity: string;
    price: string;
    tax: string;
    sku: string;
    currency: string;
}

export class ShippingAddress {
    recipient_name: string;
    line1: string;
    line2: string;
    city: string;
    country_code: string;
    postal_code: string;
    phone: string;
    state: string;
}

export class ItemList {
    items: Item[];
    shipping_address: ShippingAddress;
}

export class Transaction {
    amount: Amount;
    payee: Payee;
    description: string;
    custom: string;
    invoice_number: string;
    payment_options: PaymentOptions;
    soft_descriptor: string;
    item_list: ItemList;
    related_resources: RelatedResource[];
}

export class RedirectUrls {
    return_url: string;
    cancel_url: string;
}

export class Patch {
    op: string;
    path: string;
    value: any;
    from: string;
}

export class ExecutePaymentRequest {
    payer_id: string;
}

export class PayPalCreateTransactionRequest {
    cartGuid: string;
}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../external_api/model/paypal.ts